import React, { useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/opacity.css";
import "./Card.scss";
export default function Card({ item, showThumb, url }) {
    const [displayedImage, setDisplayedImage] = useState(() => item.image_url);
    const [thumbnails, setThumbnails] = useState([]);
    const changeThumb = (image) => {
        setDisplayedImage(image);
    };
    useEffect(() => {
        //console.log([...new Set(item.skus.map((product) => product.image1))]);
        if (showThumb)
            setThumbnails([...new Set(item.skus.map(product => product.image1))]);
    }, []);
    const handleProductClick = (sku) => {
        /* Chiamata a funzione js presente nel dom */
        const evento = window["evento"];
        if (evento) {
            evento("eStore", "Click", "Catalog" + " " + sku + "-", "SL-" + window["lingua"]);
        }
        window.location.href = `${url}?p=${item.sku_model}`;
    };
    return (React.createElement("div", { className: "product-item" },
        React.createElement(LazyLoadImage, { effect: "opacity", height: 415, src: displayedImage }),
        React.createElement("div", { className: "thumb-container" }, showThumb &&
            thumbnails.map((image, i) => (React.createElement(LazyLoadImage, { effect: "opacity", onMouseOver: () => changeThumb(image), key: i, className: "product-thumb", src: image })))),
        React.createElement("p", { className: "product-name" }, item.product_name),
        React.createElement("a", { className: "product-link", onClick: () => handleProductClick(item.sku_model) }, window["buttonPrenota"])));
}
